export default __webpack_public_path__ + "static/media/img-24-burvis.4938606e.jpg";